<template>
  <div
    class="UserRoleSelector"
    @click.prevent
  >
    <div class="Tag-container">
      <span
        v-for="tag in modelValue"
        :key="tag.value"
        class="Tag Tag--orange"
      >
        {{ tag.name }}
        <i
          class="fa fa-times"
          @click="removeTag(tag)"
        />
      </span>
    </div>
    <button
      :disabled="disabled"
      :class="{'Button--disabled': disabled }"
      class="Button Button--tertiary"
      @click="handleOpenModal"
    >
      + {{ addButtonText }}
    </button>
    <base-modal
      v-model="ui.showModal"
      extra-classes="RolesSelector-modal"
      @base-modal:opened="setUnsavedResults"
      @base-modal:closed="resetModal"
    >
      <template #modal-header>
        <tags-header
          :tags="unsavedResults"
          :modal-title="modalTitle"
          :has-quick-tag-removal="hasQuickTagRemoval"
          :is-searchable="isSearchable"
          @rmp:tag-selector:remove-tag="removeUnsavedTag"
          @rmp:tag-selector:search-input="newSearchTerm"
        />
      </template>
      <template #modal-body>
        <div class="Modal-body-content">
          <tags-body
            :tags="unsavedResults"
            :available-tags="availableTags"
            :search-term="searchTerm"
            :search-keys="searchKeys"
            @rmp:tag-selector:remove-tag="removeUnsavedTag"
            @rmp:tag-selector:add-tag="addUnsavedTag"
          />
        </div>
      </template>
      <template #modal-footer>
        <button
          class="Button Button--primary Button--long"
          @click.prevent="saveChanges"
        >
          Add to selection ({{ unsavedResults.length }})
        </button>
      </template>
    </base-modal>
  </div>
</template>
<script>
import TagSelectorMixin from '@/mixins/tag-selector-mixin';
import BaseModal from '../../modal/base-modal.vue';
import Header from './tags-header/header.vue';
import Body from './tags-body/body.vue';

export default {

  components: {
    BaseModal,
    'tags-header': Header,
    'tags-body': Body,
  },
  mixins: [TagSelectorMixin],
  props: {
    modelValue: {
      type: Array,
      default: () => [],
    },
    addButtonText: {
      type: String,
      default: 'Add',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      ui: {
        showModal: false,
      },
      unsavedResults: [],
    };
  },
  methods: {
    saveChanges() {
      // this.$bus.$emit('global-dismiss-overlays', false);
      this.ui.showModal = false;
      this.$emit('update:modelValue', this.unsavedResults);
    },
    addUnsavedTag(item) {
      this.unsavedResults = [...this.unsavedResults, item];
    },
    removeUnsavedTag(removalTag) {
      this.unsavedResults = this.unsavedResults.filter((tag) => tag.slug !== removalTag.slug);
    },
    removeTag(removalTag) {
      const newResults = this.modelValue.filter((tag) => tag.slug !== removalTag.slug);
      this.$emit('update:modelValue', newResults);
    },
    setUnsavedResults() {
      if (this.modelValue) { this.unsavedResults = [...this.modelValue]; }
    },
    handleOpenModal() {
      this.ui.showModal = true;
    },
    resetModal() {
      this.searchTerm = '';
    },
  },
};
</script>
<style lang="scss" scoped>
  @import '../../../../scss/abstracts/abstracts.scss';

  .RolesSelector-modal {
    .Modal-body-content {
      height: 400px;
      overflow: auto;
      overflow-x: hidden;
      max-height: 48vh;
    }

    .Modal-wrapper {
      width: 90%;
    }
  }

  .UserRoleSelector {
    text-align: left;
  }

  .Tag-container {
    margin: 10px 0;

    .Tag {
      margin-right: 10px;
    }
  }

  :deep(.Tag-container) {
    /*
     Tags
    */

    .Tag {
      border-radius: 4px;
      display: inline-block;
      position: relative;
      padding: 0 4px;
      color: #fff;
      font-size: 14px;
      vertical-align: middle;

      &.Tag--orange{
        background-: lighten(color($primary), 55%); // Ha ha Todo
        //background: color($primary);
        color: color($primary, 'dark');

        &.is-dark {
          background: color($primary);
          color: #fff;
        }
      }
    }

  }
</style>
